(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Pinflag-collection-grid-custom"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const carousel = document.querySelector('.mobile-carousel');
  if (carousel) {
    const interval = parseInt(carousel.dataset.carouselInterval, 10);
    let currentIndex = 0;
    let autoSlide;

    function rotateCarousel() {
      currentIndex = (currentIndex + 2) % carousel.children.length; // Move by 2 items
      carousel.scrollTo({
        left: carousel.children[currentIndex].offsetLeft,
        behavior: 'smooth'
      });
    }

    function startCarousel() {
      autoSlide = setInterval(rotateCarousel, interval);
    }

    function stopCarousel() {
      clearInterval(autoSlide);
    }

    startCarousel();

    carousel.addEventListener('touchstart', stopCarousel);
    carousel.addEventListener('click', stopCarousel);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-returns-care"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  // Init all instances on the page
  document.querySelectorAll('.vc-returns[id^="vc-returns-"]').forEach(initInstance);

  function initInstance(root) {
    // Skip if already initialized
    if (root.__vcInit) return;
    root.__vcInit = true;

    const cfg = {
      apiBase:          root.dataset.apiBase,
      apiKey:           root.dataset.apiKey,
      collectionHandle: root.dataset.collection || 'all',
      currency:         root.dataset.currency || 'CLP',
      supportEmail:     root.dataset.supportEmail || '',
      prefillEmail:     root.dataset.prefillEmail || '',
      tokenFromUrl:     new URLSearchParams(window.location.search).get('token') || null,
      prefillOrder:     new URLSearchParams(window.location.search).get('order') || '',
    };

    const $app = root.querySelector('[data-vc-app]');
    const $steps = root.querySelector('[data-vc-steps]');

    if (!$app) return;
    if (!cfg.apiKey) return;  // ya se mostró el aviso desde liquid

    const state = {
      step: 'identify',
      token: cfg.tokenFromUrl,
      order: null,
      eligibility: null,
      selectedItems: {},
      upsellItems: [],
      customerPhone: '',
      customerNotes: '',
    };

    // ─── Helpers ──────────────────────────────────────────────────────────

    function fmtMoney(amount, currency) {
      currency = currency || cfg.currency;
      try {
        return new Intl.NumberFormat('es-CL', {
          style: 'currency', currency: currency, maximumFractionDigits: 0,
        }).format(amount);
      } catch (e) { return '$' + Math.round(amount); }
    }

    function setStep(step) {
      state.step = step;
      const order = ['identify', 'verify', 'select', 'resolution', 'review', 'done'];
      const idx = order.indexOf(step);
      Array.from($steps.children).forEach((li, i) => {
        li.classList.remove('active', 'done');
        if (i < idx) li.classList.add('done');
        if (i === idx) li.classList.add('active');
      });
    }

    async function api(method, path, body) {
      const url = cfg.apiBase + path;
      const init = { method, headers: { 'X-API-Key': cfg.apiKey } };
      if (body instanceof FormData) {
        init.body = body;
      } else if (body) {
        init.headers['Content-Type'] = 'application/json';
        init.body = JSON.stringify(body);
      }
      const res = await fetch(url, init);
      const data = await res.json().catch(() => ({}));
      if (!res.ok || !data.ok) {
        throw new Error(data.error || 'Ocurrió un error procesando la solicitud.');
      }
      return data.data;
    }

    function showAlert(msg, type) {
      type = type || 'error';
      const el = document.createElement('div');
      el.className = 'vc-alert vc-alert--' + type;
      el.textContent = msg;
      $app.prepend(el);
      setTimeout(() => el.remove(), 6000);
    }

    function clearApp() { $app.innerHTML = ''; }

    function escapeHtml(str) {
      if (str == null) return '';
      return String(str)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
    }

    // ─── Paso 1: Identificación ───────────────────────────────────────────

    function renderIdentify() {
      setStep('identify');
      clearApp();
      const prefillEmail = cfg.prefillEmail || '';
      const prefillOrder = cfg.prefillOrder || '';
      $app.innerHTML = `
        <h2 style="margin:0 0 8px">Identifica tu pedido</h2>
        <p style="color:#666;margin:0 0 20px;font-size:14px">
          Ingresa tu número de pedido y el correo con que realizaste la compra.
          Te enviaremos un enlace de verificación.
        </p>
        <form data-vc-form="identify">
          <div class="vc-form-group">
            <label for="vc-order-${rootId()}">Número de pedido</label>
            <input class="vc-input" type="text" id="vc-order-${rootId()}" placeholder="#1234"
                   value="${escapeHtml(prefillOrder)}" required autocomplete="off">
          </div>
          <div class="vc-form-group">
            <label for="vc-email-${rootId()}">Correo electrónico</label>
            <input class="vc-input" type="email" id="vc-email-${rootId()}" placeholder="tucorreo@ejemplo.com"
                   value="${escapeHtml(prefillEmail)}" required autocomplete="email">
          </div>
          <div class="vc-btn-group">
            <span></span>
            <button type="submit" class="vc-btn" data-vc-submit>Enviar enlace</button>
          </div>
        </form>
      `;

      setTimeout(() => {
        const $order = $app.querySelector(`#vc-order-${rootId()}`);
        const $email = $app.querySelector(`#vc-email-${rootId()}`);
        if (prefillEmail && !prefillOrder && $order) $order.focus();
        else if (!prefillEmail && $email) $email.focus();
      }, 50);

      $app.querySelector('[data-vc-form="identify"]').addEventListener('submit', async (e) => {
        e.preventDefault();
        const order = $app.querySelector(`#vc-order-${rootId()}`).value.trim();
        const email = $app.querySelector(`#vc-email-${rootId()}`).value.trim();
        const btn = $app.querySelector('[data-vc-submit]');
        btn.disabled = true; btn.textContent = 'Enviando…';
        try {
          const data = await api('POST', '/request-token.php', { order, email });
          renderTokenSent(email, data.message);
        } catch (err) {
          showAlert(err.message);
          btn.disabled = false; btn.textContent = 'Enviar enlace';
        }
      });
    }

    function rootId() { return root.id.replace('vc-returns-', ''); }

    function renderTokenSent(email, message) {
      setStep('verify');
      clearApp();
      $app.innerHTML = `
        <div style="text-align:center;padding:24px 0">
          <div style="font-size:48px;margin-bottom:12px">📧</div>
          <h2 style="margin:0 0 8px">Revisa tu correo</h2>
          <p style="color:#666;max-width:420px;margin:0 auto 16px">
            ${escapeHtml(message || ('Enviamos un enlace a ' + email + '. Haz clic ahí para continuar con tu solicitud.'))}
          </p>
          <p style="color:#999;font-size:13px">¿No te llegó? Revisa tu carpeta de spam o intenta nuevamente.</p>
          <button class="vc-btn vc-btn--sec" data-vc-restart style="margin-top:16px">Volver a empezar</button>
        </div>
      `;
      $app.querySelector('[data-vc-restart]').addEventListener('click', renderIdentify);
    }

    // ─── Paso 2: Verificación del token ───────────────────────────────────

    async function verifyToken() {
      setStep('verify'); clearApp();
      $app.innerHTML = '<div class="vc-loading">Verificando enlace…</div>';
      try {
        const data = await api('POST', '/verify-token.php', { token: state.token });
        state.order = data.order;
        state.eligibility = data.eligibility;
        renderSelectItems();
      } catch (err) {
        clearApp();
        $app.innerHTML = `
          <div class="vc-alert vc-alert--error">${escapeHtml(err.message)}</div>
          <button class="vc-btn" data-vc-back-start>Empezar de nuevo</button>
        `;
        $app.querySelector('[data-vc-back-start]').addEventListener('click', () => {
          state.token = null;
          history.replaceState(null, '', location.pathname);
          renderIdentify();
        });
      }
    }

    // ─── Paso 3: Seleccionar productos ────────────────────────────────────

    function buildEligibilityBanner() {
      const e = state.eligibility;
      if (!e) return '';

      const labelByType = {
        size_change:    'Cambio de talla',
        product_change: 'Cambio por otro producto',
        refund:         'Devolución del dinero',
      };

      const days = e.days_elapsed;
      const isTest = e.test_mode;

      // Construir filas de "Cambio (60 días) ✓ Disponible / ✗ Vencido"
      const rows = [];
      for (const [type, info] of Object.entries(e.resolutions)) {
        const label = labelByType[type] || type;
        const icon = info.eligible
          ? '<span style="color:var(--vc-color-success)">✓</span>'
          : '<span style="color:var(--vc-color-danger)">✗</span>';
        const status = info.eligible ? 'Disponible' : 'Plazo vencido';
        rows.push(`
          <div style="display:flex;justify-content:space-between;padding:4px 0;font-size:13px">
            <span>${icon} ${label} <span style="color:var(--vc-muted)">(${info.limit} días)</span></span>
            <span style="color:${info.eligible ? 'var(--vc-color-success)' : 'var(--vc-color-danger)'}">${status}</span>
          </div>
        `);
      }
      // Garantía
      const w = e.warranty;
      const wIcon = w.eligible
        ? '<span style="color:var(--vc-color-success)">✓</span>'
        : '<span style="color:var(--vc-color-danger)">✗</span>';
      const wStatus = w.eligible ? 'Disponible' : 'Plazo vencido';
      rows.push(`
        <div style="display:flex;justify-content:space-between;padding:4px 0;font-size:13px;border-top:1px solid var(--vc-border);margin-top:6px;padding-top:8px">
          <span>${wIcon} Garantía <span style="color:var(--vc-muted)">(${w.limit} días, motivo "producto defectuoso")</span></span>
          <span style="color:${w.eligible ? 'var(--vc-color-success)' : 'var(--vc-color-danger)'}">${wStatus}</span>
        </div>
      `);

      const testWarning = isTest
        ? `<div style="background:#fef3c7;color:#92400e;padding:8px 12px;border-radius:6px;font-size:12px;margin-top:8px">
            <strong>Modo prueba activo:</strong> el sistema permitirá enviar la solicitud aunque el plazo esté vencido.
           </div>`
        : '';

      return `
        <div class="vc-alert vc-alert--info" style="margin-bottom:16px">
          <div style="font-weight:500;margin-bottom:6px">
            Pedido realizado hace ${days} ${days === 1 ? 'día' : 'días'} (${e.order_date})
          </div>
          ${rows.join('')}
          ${testWarning}
        </div>
      `;
    }

    function renderSelectItems() {
      setStep('select'); clearApp();
      const lineItems = state.order.line_items;
      const itemsHtml = lineItems.map((li) => `
        <label class="vc-item" data-vc-li="${escapeHtml(li.line_item_id)}">
          <input type="checkbox" class="vc-check" data-vc-li-check="${escapeHtml(li.line_item_id)}"
                 ${state.selectedItems[li.line_item_id] ? 'checked' : ''}>
          <img class="vc-item__img" src="${escapeHtml(li.image || '')}" alt="" onerror="this.style.visibility='hidden'">
          <div class="vc-item__info">
            <div class="vc-item__title">${escapeHtml(li.title)}</div>
            <div class="vc-item__variant">${escapeHtml(li.variant_title || '')}</div>
            <div class="vc-item__meta">SKU: ${escapeHtml(li.sku)} · Cantidad: ${li.quantity} · ${fmtMoney(li.price)}</div>
          </div>
        </label>
      `).join('');

      $app.innerHTML = `
        <h2 style="margin:0 0 8px">Pedido ${escapeHtml(state.order.name)}</h2>
        <p style="color:#666;margin:0 0 16px;font-size:14px">
          Selecciona los productos que deseas cambiar o devolver.
        </p>
        ${buildEligibilityBanner()}
        <div class="vc-items-list">${itemsHtml}</div>
        <div class="vc-btn-group">
          <button class="vc-btn vc-btn--sec" data-vc-back-ident>Volver</button>
          <button class="vc-btn" data-vc-next-res disabled>Continuar</button>
        </div>
      `;

      $app.querySelectorAll('[data-vc-li-check]').forEach((cb) => {
        cb.addEventListener('change', (e) => {
          const liId = e.target.dataset.vcLiCheck;
          const item = lineItems.find((x) => String(x.line_item_id) === String(liId));
          if (e.target.checked) {
            state.selectedItems[liId] = {
              line_item: item,
              resolution_type: null, reason_code: null, reason_notes: '',
              photos: [], new_variant: null,
            };
          } else {
            delete state.selectedItems[liId];
          }
          e.target.closest('.vc-item').classList.toggle('selected', e.target.checked);
          $app.querySelector('[data-vc-next-res]').disabled = Object.keys(state.selectedItems).length === 0;
        });
        if (state.selectedItems[cb.dataset.vcLiCheck]) {
          cb.closest('.vc-item').classList.add('selected');
          $app.querySelector('[data-vc-next-res]').disabled = false;
        }
      });

      $app.querySelector('[data-vc-back-ident]').addEventListener('click', () => {
        if (confirm('¿Salir del proceso? Se perderá lo seleccionado.')) {
          state.selectedItems = {};
          renderIdentify();
        }
      });
      $app.querySelector('[data-vc-next-res]').addEventListener('click', renderResolution);
    }

    // ─── Paso 4: Resolución ───────────────────────────────────────────────

    const RESOLUTION_TYPES = {
      size_change:    { label: 'Cambio de talla',          icon: '📏' },
      product_change: { label: 'Cambio por otro producto', icon: '🔄' },
      refund:         { label: 'Devolución del dinero',    icon: '💰' },
    };

    const REASONS = {
      size_too_small:   'La talla es muy pequeña',
      size_too_big:     'La talla es muy grande',
      defective:        'Producto defectuoso',
      wrong_item:       'Recibí un producto distinto',
      not_as_described: 'No es como se mostraba en el sitio',
      damaged_shipping: 'Llegó dañado en el envío',
      changed_mind:     'Cambié de opinión',
      quality:          'Calidad inferior a la esperada',
      other:            'Otro (especificar)',
    };

    function renderResolution() {
      setStep('resolution'); clearApp();

      const cards = Object.keys(state.selectedItems).map((liId) => {
        const sel = state.selectedItems[liId];
        const li = sel.line_item;

        const resolutionBtns = Object.entries(RESOLUTION_TYPES).map(([key, val]) => `
          <div class="vc-res-opt ${sel.resolution_type === key ? 'selected' : ''}"
               data-vc-li="${escapeHtml(liId)}" data-vc-resolution="${key}">
            ${val.icon} ${val.label}
          </div>
        `).join('');

        const reasonsOpts = Object.entries(REASONS).map(([key, label]) =>
          `<option value="${key}" ${sel.reason_code === key ? 'selected' : ''}>${escapeHtml(label)}</option>`
        ).join('');

        const newVariantSummary = sel.new_variant ? `
          <div class="vc-alert vc-alert--info" style="margin-top:12px">
            <strong>Reemplazo:</strong> ${escapeHtml(sel.new_variant.product_title)} – ${escapeHtml(sel.new_variant.variant_title)}
            (${fmtMoney(sel.new_variant.price)})
            <button class="vc-btn vc-btn--sec" style="float:right;padding:4px 10px;font-size:12px" data-vc-change-variant="${escapeHtml(liId)}">Cambiar</button>
          </div>
        ` : '';

        const needsPicker = (sel.resolution_type === 'size_change' || sel.resolution_type === 'product_change') && !sel.new_variant;

        return `
          <div class="vc-res-card" data-vc-li-card="${escapeHtml(liId)}">
            <div class="vc-res-card__hdr">
              <img class="vc-item__img" src="${escapeHtml(li.image || '')}" style="width:56px;height:56px" alt="">
              <div>
                <div class="vc-item__title">${escapeHtml(li.title)}</div>
                <div class="vc-item__variant">${escapeHtml(li.variant_title || '')} · ${fmtMoney(li.price)}</div>
              </div>
            </div>

            <label style="font-size:13px;font-weight:500;display:block;margin-bottom:8px">¿Qué deseas obtener?</label>
            <div class="vc-res-opts">${resolutionBtns}</div>

            ${needsPicker ? `
              <button class="vc-btn vc-btn--sec" data-vc-pick-variant="${escapeHtml(liId)}" style="margin-bottom:12px">
                ${sel.resolution_type === 'size_change' ? 'Elegir nueva talla' : 'Elegir producto de reemplazo'}
              </button>
            ` : ''}

            ${newVariantSummary}

            <div class="vc-form-group" style="margin-top:12px">
              <label>Motivo</label>
              <select class="vc-select" data-vc-reason="${escapeHtml(liId)}">
                <option value="">Selecciona un motivo…</option>
                ${reasonsOpts}
              </select>
            </div>

            <div class="vc-form-group">
              <label>Comentarios adicionales (opcional)</label>
              <textarea class="vc-textarea" data-vc-notes="${escapeHtml(liId)}" placeholder="Cuéntanos más detalles…">${escapeHtml(sel.reason_notes || '')}</textarea>
            </div>

            <div class="vc-form-group">
              <label>Fotos (opcional, hasta 4)</label>
              <div class="vc-photos" data-vc-photos="${escapeHtml(liId)}">
                ${(sel.photos || []).map((url, i) => `
                  <div class="vc-photo-thumb">
                    <img src="${escapeHtml(url)}" alt="">
                    <button data-vc-rm-photo="${escapeHtml(liId)}:${i}" type="button">×</button>
                  </div>
                `).join('')}
                ${(sel.photos || []).length < 4 ? `
                  <label class="vc-photo-add">
                    +
                    <input type="file" accept="image/*" data-vc-upload="${escapeHtml(liId)}" style="display:none">
                  </label>
                ` : ''}
              </div>
            </div>
          </div>
        `;
      }).join('');

      $app.innerHTML = `
        <h2 style="margin:0 0 8px">¿Cómo te ayudamos?</h2>
        <p style="color:#666;margin:0 0 20px;font-size:14px">
          Para cada producto, elige el tipo de resolución y cuéntanos el motivo.
        </p>
        ${cards}
        <div class="vc-btn-group">
          <button class="vc-btn vc-btn--sec" data-vc-back-select>Volver</button>
          <button class="vc-btn" data-vc-next-review>Continuar</button>
        </div>
      `;

      $app.querySelectorAll('[data-vc-resolution]').forEach((el) => {
        el.addEventListener('click', () => {
          const liId = el.dataset.vcLi;
          const res = el.dataset.vcResolution;
          const prev = state.selectedItems[liId].resolution_type;
          state.selectedItems[liId].resolution_type = res;
          if (prev !== res && res === 'refund') {
            state.selectedItems[liId].new_variant = null;
          }
          renderResolution();
        });
      });

      $app.querySelectorAll('[data-vc-reason]').forEach((el) => {
        el.addEventListener('change', () => {
          state.selectedItems[el.dataset.vcReason].reason_code = el.value;
        });
      });

      $app.querySelectorAll('[data-vc-notes]').forEach((el) => {
        el.addEventListener('input', () => {
          state.selectedItems[el.dataset.vcNotes].reason_notes = el.value;
        });
      });

      $app.querySelectorAll('[data-vc-pick-variant]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const liId = btn.dataset.vcPickVariant;
          const sel = state.selectedItems[liId];
          if (sel.resolution_type === 'size_change') {
            openVariantPickerForSameProduct(liId);
          } else {
            openProductPicker(liId);
          }
        });
      });

      $app.querySelectorAll('[data-vc-change-variant]').forEach((btn) => {
        btn.addEventListener('click', () => {
          state.selectedItems[btn.dataset.vcChangeVariant].new_variant = null;
          renderResolution();
        });
      });

      $app.querySelectorAll('[data-vc-upload]').forEach((input) => {
        input.addEventListener('change', async (e) => {
          const liId = e.target.dataset.vcUpload;
          const file = e.target.files[0];
          if (!file) return;
          await uploadPhoto(liId, file);
          renderResolution();
        });
      });
      $app.querySelectorAll('[data-vc-rm-photo]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const parts = btn.dataset.vcRmPhoto.split(':');
          const liId = parts[0], idx = parseInt(parts[1], 10);
          state.selectedItems[liId].photos.splice(idx, 1);
          renderResolution();
        });
      });

      $app.querySelector('[data-vc-back-select]').addEventListener('click', renderSelectItems);
      $app.querySelector('[data-vc-next-review]').addEventListener('click', () => {
        for (const liId in state.selectedItems) {
          const sel = state.selectedItems[liId];
          if (!sel.resolution_type)  { showAlert('Debes elegir el tipo de resolución para todos los productos.'); return; }
          if (!sel.reason_code)      { showAlert('Debes seleccionar un motivo para todos los productos.'); return; }
          if ((sel.resolution_type === 'size_change' || sel.resolution_type === 'product_change') && !sel.new_variant) {
            showAlert('Debes elegir el producto de reemplazo.'); return;
          }
        }
        renderUpsellOrReview();
      });
    }

    async function uploadPhoto(liId, file) {
      const fd = new FormData();
      fd.append('token', state.token);
      fd.append('photo', file);
      try {
        const data = await api('POST', '/upload-photo.php', fd);
        state.selectedItems[liId].photos = state.selectedItems[liId].photos || [];
        state.selectedItems[liId].photos.push(data.url);
      } catch (err) {
        showAlert('Error subiendo la foto: ' + err.message);
      }
    }

    // ─── Pickers de variante / producto ──────────────────────────────────

    async function openVariantPickerForSameProduct(liId) {
      showModal('<div class="vc-loading">Cargando opciones…</div>');
      try {
        const sel = state.selectedItems[liId];
        const qs = '?token=' + encodeURIComponent(state.token) + '&q=' + encodeURIComponent(sel.line_item.title);
        const data = await api('GET', '/products.php' + qs);
        const product = (data.products || []).find((p) => String(p.id) === String(sel.line_item.product_id)) || data.products[0];
        if (!product) {
          closeModal(); showAlert('No se encontraron variantes disponibles.'); return;
        }
        renderVariantPicker(liId, product, false);
      } catch (err) {
        closeModal(); showAlert(err.message);
      }
    }

    function sortVariantsByTitle(variants) {
      // Orden esperado de tallas (mayor cobertura de la industria)
      const sizeOrder = [
        'XXXS', '3XS',
        'XXS', '2XS',
        'XS',
        'S', 'CH', 'P', 'PEQUEÑA', 'PEQUEÑO',
        'M', 'MEDIANA', 'MEDIANO',
        'L', 'G', 'GRANDE',
        'XL', '1XL', 'XG',
        'XXL', '2XL', 'XXG',
        'XXXL', '3XL',
        '4XL', '5XL', '6XL',
      ];
      const sizeRank = {};
      sizeOrder.forEach((s, i) => { sizeRank[s.toUpperCase()] = i; });

      function rankOf(title) {
        if (!title) return 999999;
        const t = String(title).trim().toUpperCase();
        // Talla simbólica conocida
        if (sizeRank[t] !== undefined) return sizeRank[t];
        // Número puro (ej: "38", "40", "42")
        const num = parseFloat(t.replace(',', '.'));
        if (!isNaN(num) && isFinite(num)) return 100000 + num;
        // Talla única o lo que no se reconoce: al final
        return 999999;
      }

      return [...variants].sort((a, b) => {
        const ra = rankOf(a.title);
        const rb = rankOf(b.title);
        if (ra !== rb) return ra - rb;
        // Si ambos sin reconocer, ordenar alfabéticamente
        return String(a.title || '').localeCompare(String(b.title || ''));
      });
    }

    function renderVariantPicker(liId, product, isUpsell, backTo) {
      const sortedVariants = sortVariantsByTitle(product.variants || []);
      const variantsHtml = sortedVariants.map((v) => `
        <button class="vc-variant-btn" data-vc-pick="${escapeHtml(v.id)}"
                data-title="${escapeHtml(v.title)}" data-price="${v.price}" data-sku="${escapeHtml(v.sku || '')}"
                ${!v.available ? 'disabled' : ''}>
          ${escapeHtml(v.title)}${isUpsell ? ' – ' + fmtMoney(v.price) : ''}
        </button>
      `).join('');

      const backBtn = backTo
        ? `<button class="vc-btn vc-btn--sec" data-vc-back-picker style="margin-bottom:12px;padding:6px 12px;font-size:13px">← Elegir otro producto</button>`
        : '';

      showModal(`
        ${backBtn}
        <h3 style="margin:0 0 12px">${escapeHtml(product.title)}</h3>
        <p style="color:#666;font-size:13px;margin:0 0 12px">${isUpsell ? 'Elige la variante' : 'Elige la talla de reemplazo'}</p>
        <div class="vc-variant-list">${variantsHtml}</div>
      `);

      const $backBtn = document.querySelector('[data-vc-back-picker]');
      if ($backBtn && backTo) {
        $backBtn.addEventListener('click', () => {
          backTo();
        });
      }

      document.querySelectorAll('[data-vc-pick]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const variant = {
            product_id: product.id,
            variant_id: btn.dataset.vcPick,
            product_title: product.title,
            variant_title: btn.dataset.title,
            sku: btn.dataset.sku,
            price: parseFloat(btn.dataset.price),
            image: product.image,
          };
          if (isUpsell) {
            state.upsellItems.push({ product: { id: product.id, title: product.title, image: product.image }, variant });
            closeModal();
            renderUpsellOrReview();
          } else {
            state.selectedItems[liId].new_variant = variant;
            closeModal();
            renderResolution();
          }
        });
      });
    }

    async function openProductPicker(liId) {
      showModal(`
        <h3 style="margin:0 0 12px">Elige un producto</h3>
        <div class="vc-search-row">
          <input class="vc-input" data-vc-search type="search" placeholder="Buscar por nombre o SKU…">
        </div>
        <div data-vc-product-grid><div class="vc-loading">Cargando productos…</div></div>
      `);

      const $grid = document.querySelector('[data-vc-product-grid]');
      const $search = document.querySelector('[data-vc-search]');

      const load = async (q) => {
        q = q || '';
        $grid.innerHTML = '<div class="vc-loading">Cargando…</div>';
        try {
          let qs = '?token=' + encodeURIComponent(state.token);
          if (q) {
            qs += '&q=' + encodeURIComponent(q);
          } else if (cfg.collectionHandle) {
            qs += '&collection=' + encodeURIComponent(cfg.collectionHandle);
          }
          const data = await api('GET', '/products.php' + qs);
          renderProductGrid(liId, data.products, $grid, false, () => openProductPicker(liId));
        } catch (err) {
          $grid.innerHTML = '<div class="vc-alert vc-alert--error">' + escapeHtml(err.message) + '</div>';
        }
      };

      let timer;
      $search.addEventListener('input', () => {
        clearTimeout(timer);
        timer = setTimeout(() => load($search.value.trim()), 300);
      });
      load();
    }

    function renderProductGrid(liId, products, $grid, isUpsell, backTo) {
      if (!products || products.length === 0) {
        $grid.innerHTML = '<p style="color:#666;text-align:center;padding:20px">No se encontraron productos.</p>';
        return;
      }
      $grid.innerHTML = `
        <div class="vc-products-grid">
          ${products.map((p) => `
            <div class="vc-product-card" data-vc-product="${escapeHtml(p.id)}">
              <img src="${escapeHtml(p.image || '')}" alt="" onerror="this.style.visibility='hidden'">
              <div class="vc-product-card__body">
                <div class="vc-product-card__title">${escapeHtml(p.title)}</div>
                <div class="vc-product-card__price">Desde ${fmtMoney(p.price_from)}</div>
              </div>
            </div>
          `).join('')}
        </div>
      `;
      $grid.querySelectorAll('[data-vc-product]').forEach((card) => {
        card.addEventListener('click', () => {
          const product = products.find((p) => String(p.id) === card.dataset.vcProduct);
          renderVariantPicker(liId, product, isUpsell, backTo);
        });
      });
    }

    // ─── Modal genérico ──────────────────────────────────────────────────

    function showModal(html) {
      closeModal();
      const modal = document.createElement('div');
      modal.className = 'vc-modal';
      modal.setAttribute('data-vc-modal', '');
      modal.innerHTML = `
        <div class="vc-modal__content">
          <button class="vc-modal__close" type="button" aria-label="Cerrar">×</button>
          ${html}
        </div>
      `;
      document.body.appendChild(modal);
      modal.querySelector('.vc-modal__close').addEventListener('click', closeModal);
      modal.addEventListener('click', (e) => { if (e.target === modal) closeModal(); });
    }
    function closeModal() {
      const m = document.querySelector('[data-vc-modal]');
      if (m) m.remove();
    }

    // ─── Paso 5: Upsell + Revisión ───────────────────────────────────────

    function renderUpsellOrReview() {
      setStep('review'); clearApp();
      const totals = computeTotals();

      const upsellsHtml = state.upsellItems.map((u, i) => `
        <div class="vc-item">
          <img class="vc-item__img" src="${escapeHtml(u.product.image || '')}" alt="">
          <div class="vc-item__info">
            <div class="vc-item__title">${escapeHtml(u.product.title)}
              <span style="background:#fef3c7;font-size:11px;padding:2px 6px;border-radius:4px;margin-left:6px">Agregado</span>
            </div>
            <div class="vc-item__variant">${escapeHtml(u.variant.variant_title)}</div>
            <div class="vc-item__meta">${fmtMoney(u.variant.price)}</div>
          </div>
          <div class="vc-item__actions">
            <button class="vc-btn vc-btn--sec" data-vc-rm-upsell="${i}" style="padding:6px 12px;font-size:12px">Quitar</button>
          </div>
        </div>
      `).join('');

      $app.innerHTML = `
        <h2 style="margin:0 0 8px">Revisa tu solicitud</h2>
        <p style="color:#666;margin:0 0 20px;font-size:14px">¿Quieres agregar algo más a tu pedido?</p>

        <div class="vc-summary">
          <div class="vc-summary__row">
            <span>Productos a cambiar/devolver</span>
            <span>${Object.keys(state.selectedItems).length}</span>
          </div>
          ${totals.refund > 0 ? `<div class="vc-summary__row"><span>Monto a reembolsar/gift card</span><span style="color:var(--vc-color-success)">+${fmtMoney(totals.refund)}</span></div>` : ''}
          ${totals.extra_charge > 0 ? `<div class="vc-summary__row"><span>Diferencia a pagar</span><span style="color:var(--vc-color-danger)">${fmtMoney(totals.extra_charge)}</span></div>` : ''}
        </div>

        ${state.upsellItems.length > 0 ? `
          <h3 style="font-size:15px;margin:24px 0 12px">Productos agregados</h3>
          <div class="vc-items-list">${upsellsHtml}</div>
        ` : ''}

        <button class="vc-btn vc-btn--sec" data-vc-add-upsell style="margin-top:16px">+ Agregar otro producto</button>

        <h3 style="font-size:15px;margin:24px 0 12px">Datos de contacto</h3>
        <div class="vc-form-group">
          <label>Teléfono (opcional, para coordinar el retiro)</label>
          <input class="vc-input" type="tel" data-vc-phone value="${escapeHtml(state.customerPhone || state.order.customer.phone || '')}" placeholder="+56 9 1234 5678">
        </div>
        <div class="vc-form-group">
          <label>Comentarios adicionales (opcional)</label>
          <textarea class="vc-textarea" data-vc-notes-final placeholder="¿Algo más que debamos saber?">${escapeHtml(state.customerNotes || '')}</textarea>
        </div>

        <div class="vc-btn-group">
          <button class="vc-btn vc-btn--sec" data-vc-back-res>Volver</button>
          <button class="vc-btn" data-vc-submit-final>Enviar solicitud</button>
        </div>
      `;

      $app.querySelector('[data-vc-add-upsell]').addEventListener('click', openUpsellPicker);
      $app.querySelectorAll('[data-vc-rm-upsell]').forEach((btn) => {
        btn.addEventListener('click', () => {
          state.upsellItems.splice(parseInt(btn.dataset.vcRmUpsell, 10), 1);
          renderUpsellOrReview();
        });
      });
      $app.querySelector('[data-vc-phone]').addEventListener('input', (e) => { state.customerPhone = e.target.value; });
      $app.querySelector('[data-vc-notes-final]').addEventListener('input', (e) => { state.customerNotes = e.target.value; });
      $app.querySelector('[data-vc-back-res]').addEventListener('click', renderResolution);
      $app.querySelector('[data-vc-submit-final]').addEventListener('click', submitRequest);
    }

    function openUpsellPicker() {
      showModal(`
        <h3 style="margin:0 0 12px">Agregar producto</h3>
        <div class="vc-search-row">
          <input class="vc-input" data-vc-search-upsell type="search" placeholder="Buscar productos…">
        </div>
        <div data-vc-upsell-grid><div class="vc-loading">Cargando…</div></div>
      `);

      const $grid = document.querySelector('[data-vc-upsell-grid]');
      const $search = document.querySelector('[data-vc-search-upsell]');

      const load = async (q) => {
        q = q || '';
        $grid.innerHTML = '<div class="vc-loading">Cargando…</div>';
        try {
          let qs = '?token=' + encodeURIComponent(state.token);
          if (q) {
            qs += '&q=' + encodeURIComponent(q);
          } else if (cfg.collectionHandle) {
            qs += '&collection=' + encodeURIComponent(cfg.collectionHandle);
          }
          const data = await api('GET', '/products.php' + qs);
          renderProductGrid(null, data.products, $grid, true, () => openUpsellPicker());
        } catch (err) {
          $grid.innerHTML = '<div class="vc-alert vc-alert--error">' + escapeHtml(err.message) + '</div>';
        }
      };

      let timer;
      $search.addEventListener('input', () => {
        clearTimeout(timer);
        timer = setTimeout(() => load($search.value.trim()), 300);
      });
      load();
    }

    function computeTotals() {
      let refund = 0, extra = 0;
      for (const liId in state.selectedItems) {
        const sel = state.selectedItems[liId];
        const original = sel.line_item.price * sel.line_item.quantity;
        switch (sel.resolution_type) {
          case 'refund':
            refund += original; break;
          case 'product_change':
            if (sel.new_variant) {
              const diff = sel.new_variant.price - sel.line_item.price;
              if (diff > 0) extra += diff;
              else refund += Math.abs(diff);
            }
            break;
        }
      }
      state.upsellItems.forEach((u) => { extra += u.variant.price; });
      return { refund, extra_charge: extra };
    }

    // ─── Submit ───────────────────────────────────────────────────────────

    async function submitRequest() {
      const btn = $app.querySelector('[data-vc-submit-final]');
      btn.disabled = true; btn.textContent = 'Enviando…';

      const items = [];
      for (const liId in state.selectedItems) {
        const sel = state.selectedItems[liId];
        const item = {
          original_line_item_id: liId,
          quantity: sel.line_item.quantity,
          resolution_type: sel.resolution_type,
          reason_code: sel.reason_code,
          reason_notes: sel.reason_notes || null,
          photos: sel.photos || [],
        };
        if (sel.new_variant) {
          item.new_product_id    = sel.new_variant.product_id;
          item.new_variant_id    = sel.new_variant.variant_id;
          item.new_product_title = sel.new_variant.product_title;
          item.new_variant_title = sel.new_variant.variant_title;
          item.new_sku           = sel.new_variant.sku;
          item.new_price         = sel.new_variant.price;
        }
        items.push(item);
      }
      state.upsellItems.forEach((u) => {
        items.push({
          is_upsell: true,
          new_product_id:    u.product.id,
          new_variant_id:    u.variant.variant_id,
          new_product_title: u.product.title,
          new_variant_title: u.variant.variant_title,
          new_sku:           u.variant.sku,
          new_price:         u.variant.price,
          resolution_type:   'upsell',
        });
      });

      try {
        const data = await api('POST', '/submit.php', {
          token: state.token,
          customer_phone: state.customerPhone,
          customer_notes: state.customerNotes,
          items: items,
        });
        renderSuccess(data);
      } catch (err) {
        showAlert(err.message);
        btn.disabled = false; btn.textContent = 'Enviar solicitud';
      }
    }

    function renderSuccess(data) {
      setStep('done'); clearApp();
      const code = data.ticket_code || ('#' + data.ticket_id);
      $app.innerHTML = `
        <div class="vc-success">
          <div class="vc-success__icon">✓</div>
          <h2>¡Solicitud enviada!</h2>
          <p style="color:#666;max-width:480px;margin:0 auto">${escapeHtml(data.message)}</p>
          <div class="vc-success__ticket">Ticket ${escapeHtml(code)}</div>
          <p style="color:#999;font-size:13px;max-width:480px;margin:16px auto 0">
            Te enviaremos un correo cuando aprobemos tu solicitud, junto con la etiqueta para devolver el producto.
          </p>
        </div>
      `;
    }

    // ─── Inicio ──────────────────────────────────────────────────────────
    if (state.token) {
      verifyToken();
    } else {
      renderIdentify();
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
document.querySelectorAll('.card').forEach(card => {
  card.style.pointerEvents = 'none';
});

  } catch(e) { console.error(e); }
})();
})();
